    import { Fragment, useEffect, useRef, useState, useMemo, FC } from 'react';
    import { FacebookIcon } from '@ui/icons/social/facebook';
    import { InstagramIcon } from '@ui/icons/social/instagram';
    import { YoutubeIcon } from '@ui/icons/social/youtube';
    import { LandingNavbar } from '@app/landing/landing-navbar';
    import { Swiper, SwiperSlide } from "swiper/react";
    import "swiper/css";
    import "swiper/css/pagination";
    import { Pagination } from "swiper/modules";
    import { color, motion } from "framer-motion";
    import { Sparkles, User } from 'lucide-react';
    import { Shield, ShieldCheck, Share2, UserPlus, Upload, Globe2, Gift, SlidersHorizontal, Layers,FolderKanban, Rocket  } from "lucide-react";
    import {  Lock, Database, FileCheck, Users, Eye,  Globe , Zap , Wifi , FolderPlus ,Cpu,FolderX ,ShieldOff, Key  } from 'lucide-react';
    import {  Megaphone , TrendingUp , Cloud, Building2, Compass, Briefcase,  } from 'lucide-react';
    import { BillingCycleRadio } from '@common/billing/pricing-table/billing-cycle-radio';
    import { PricingTable } from '@common/billing/pricing-table/pricing-table';
    import {
      ContactPagePayload,
      useSubmitContactForm,
    } from '@common/contact/use-submit-contact-form';
    import { useForm } from 'react-hook-form';
    import { Dialog } from '@ui/overlays/dialog/dialog';
    import { DialogBody } from '@ui/overlays/dialog/dialog-body';
    import { DialogHeader } from '@ui/overlays/dialog/dialog-header';
    import { DialogTrigger } from '@ui/overlays/dialog/dialog-trigger';
    import { FormTextField } from '@ui/forms/input-field/text-field/text-field';
    import { useRecaptcha } from '@common/recaptcha/use-recaptcha';
    import { Button } from '@ui/buttons/button';
    import { Trans } from '@ui/i18n/trans';
    import { Form } from '@ui/forms/form';
    import { UpsellBillingCycle } from '@common/billing/pricing-table/find-best-price';
    import { useProducts } from '@common/billing/pricing-table/use-products';
    import { CheckCircleOutlineIcon } from '@ui/icons/material/CheckCircleOutline';
    import { FullPageLoader } from '@ui/progress/full-page-loader';
    import { ArrowLeftIcon } from '@ui/icons/material/ArrowLeftIcon';
    import { ArrowRightIcon } from '@ui/icons/material/ArrowRightIcon';
    import { LucideIcon } from "lucide-react";
    import { useThemeSelector } from '@ui/themes/theme-selector-context';
    import { Helmet } from "@common/seo/helmet";
    import {
    History,
    CloudOff,BarChart3,
    Users2,CloudCheck, HardDrive,
    AlertCircle
    } from "lucide-react";

    export function GoogleDriveAlternative() {
      const query = useProducts('pricingPage');
        const [selectedCycle, setSelectedCycle] =
          useState<UpsellBillingCycle>('month');
    
        const { selectThemeTemporarily } = useThemeSelector();
      useEffect(() => {
        selectThemeTemporarily('light');
        return () => selectThemeTemporarily(null);
      }, [selectThemeTemporarily]);
    
     const steps = [
        {
          icon: UserPlus,
          number: '01',
          title: 'Sign Up',
          description: 'Create your account in seconds with no credit card required',
        },
        {
          icon: Upload,
          number: '02',
          title: 'Upload Files',
          description: 'Upload files or sync folders instantly with secure, high-speed cloud storage',
        },
        {
          icon: Globe2,
          number: '03',
          title: 'Access Anywhere',
          description: 'Access your data from any device, anywhere in the world',
        },
      ];
    
      
    
      interface Card {
        icon: LucideIcon;
        title: string;
        description: string;
      }
        const [isMobile, setIsMobile] = useState<boolean>(false);
        const [hoverIndex, setHoverIndex] = useState<number | null>(null);
      
        useEffect(() => {
          const handleResize = () => {
            setIsMobile(window.innerWidth < 992);
          };
      
          handleResize();
          window.addEventListener("resize", handleResize);
          return () => window.removeEventListener("resize", handleResize);
        }, []);
      
        const card: Card[] = [
        {
          icon: FolderKanban,
          title: "Organized project assets",
          description: "Keep all marketing content and data sorted and accessible from one secure cloud platform.",
        },
        {
          icon: Globe  ,
          title: "Anywhere access",
          description: "Retrieve files remotely, enabling work from any device or location.",
        },
        {
          icon: ShieldCheck ,
          title: "Enhanced security",
          description: "Advanced encryption and backups protect sensitive digital marketing data.",
        },
        {
          icon: Users ,
          title: "Seamless collaboration",
          description: "Share and edit files with teams in real time for faster marketing execution.",
        },
      ];

        // const rows = [
        //   { title: "Security", gdrive: " Google security infrastructure", space: "AES-256 + TLS 1.3 encryption" },
        //   { title: "End-to-End Encryption", gdrive: "No", space: "Yes" },
        //   { title: "Speed", gdrive: "Upload(5 MBPS) Download(400 KBPS)", space: "High-Speed Upload/Download" },
        //   { title: "Price (India)", gdrive: "₹130/month (100 GB)", space: "₹20 - ₹150/month (50 GB-1 TB) + unlimited options" },
        //   { title: "Free Tier", gdrive: "15 GB", space: "25 GB" },
        //   { title: "Ads Shown", gdrive: "No", space: "No" },
        //   { title: "Maximum File Size", gdrive: "Up to 5TB", space: "No file size restrictions" },
        //   {
        //     title: "Daily Upload Limit",
        //     gdrive: "750GB per day limit",
        //     space: "No daily upload limits",
        //   },
        //   { title: "Large File Handling", gdrive: "Can feel restrictive for heavy use", space: "Smooth handling of large files" },
        //   { title: "Workflow ", gdrive: "Uploads stop after hitting limits", space: "No interruptions" },

        // ];


      const cards  : {
          title: string;
          desc: React.ReactNode;
          icon: React.ReactNode;
          color: string;
        }[] = [
        {
          icon: <HardDrive   className="w-24 h-24 text-white" />,
          title: "Storage gets full quickly",
          desc: "At first, 15GB feels enough, but over time Gmail, Photos, and Drive share space, filling it faster than you expect.",
          color: 'from-[#1E3A8A] to-[#3B82F6]',
        },
        {
          icon: <ShieldOff  className="w-24 h-24 text-white" />,
          title: "No full encryption privacy",
          desc: "Google Drive keeps your files secure with encryption, but it doesn’t offer full end-to-end encryption, meaning Google still controls the keys and your data isn’t completely private.",
          color: 'from-[#3B82F6] to-[#60A5FA]',
        },
        {
          icon: <FolderX  className="w-24 h-24 text-white" />,
          title: "Limited file control",
          desc: "Sharing files is simple, but control feels limited, as basic permissions make it harder to manage exactly who can view or edit files.",
          color: 'from-[#06B6D4] to-[#3B82F6]',
        },
          {
          icon: <Cpu  className="w-24 h-24 text-white" />,
          title: "Not ideal for heavy workloads",
          desc: "It works well for normal use. But when you start handling large videos, backups, or bigger projects, it can feel slower, and managing everything isn’t always smooth.",
          color: 'from-[#1E3A8A] to-[#06B6D4]',
        },
        {
          icon: <FolderPlus   className="w-24 h-24 text-white" />,
          title: "No file size limits",
          desc: "Google Drive supports files up to 5TB, which sounds good. But daily upload limits and storage caps can still create problems if you regularly work with large files.",
          color: 'from-[#3B82F6] to-[#1E3A8A]',
        },
      ];

      const [openIndex, setOpenIndex] = useState<number | null>(0);
    
      const toggle = (index: number) => {
        setOpenIndex(openIndex === index ? null : index);
      };
    
      const faqData = [
        {
          question: "Is SpaceByte the best Google Drive alternative?",
          answer: "Yes, if you value privacy, SpaceByte is the <strong>best Google Drive alternative</strong>. As a powerful <strong>Google Drive replacement</strong>, it offers true zero-knowledge encryption. Furthermore, as an <strong>Indian alternative to Google Drive</strong>, it's also a much <strong>cheaper Google Drive alternative</strong> without any hidden foreign exchange fees."
        },
          {
            question: "How does cloud storage google compare to google cloud platform?",
            answer: "While <strong>google cloud platform</strong> (GCP) is for developers, consumer <strong>cloud storage google</strong> (Google Drive) suffers from shared storage limits. Moving away from a standard <strong>google cloud</strong> ecosystem to SpaceByte prevents shared-drive permission leaks and hidden fees.",
          },
          {
            question: "Why switch from legacy cloud storage?",
            answer: "Switching to a <strong>smart Google Drive alternative</strong> helps you avoid <strong>the egress and bandwidth traps</strong> and eliminates <strong>the continuous syncing overhead</strong> that slows down high-performance workflows.",
          },
          {
            question: "How is SpaceByte different from Google Drive?",
            answer:
                "SpaceByte feels less restrictive than Google Drive, with end-to-end encryption keeping your files private, and no upload or bandwidth limits, making it easier to manage and share large files smoothly.",
          },
          {
            question: "Is Google Drive secure enough?",
            answer:
              "Google Drive is generally safe for everyday use, but it lacks full end-to-end encryption. SpaceByte Cloud Storage adds stronger privacy with AES-256 storage encryption and TLS 1.3 transfers for extra reassurance and better control.",
          },
          {
            question: "Which cloud storage is best for large files?",
            answer:
              "If you work with large files often, it really helps to use something that doesn’t keep stopping you with limits. SpaceByte fits perfectly here since you don’t have to think much about storage or file size. You can upload big files, share them through a link or even send them by email, and it all just feels a bit easier to handle day to day.",
          },
          {
            question: "Why do users look for alternatives to Google Drive?",
            answer:
              "Users often look for <strong>cloud storage alternatives to google</strong> when storage fills up quickly, uploads slow down, or they want more control. This leads them to search for a <strong>google alternative cloud storage</strong> like SpaceByte, which is arguably <strong>better cloud storage than google drive</strong> due to enhanced privacy.",
          },
          {
            question: "Is there a cloud storage cheaper than Google Drive?",
            answer: "Yes, SpaceByte is a <strong>cloud storage cheaper than google drive</strong> because it charges in INR without foreign exchange markups. In a direct comparison of <strong>cloud storage vs google drive</strong> (or <strong>cloud storage vs google storage</strong>), SpaceByte offers a much lower cost per TB. If you want a <strong>cloud storage like google drive</strong> but <strong>better cloud storage than google</strong> when it comes to pricing and zero AI scraping, SpaceByte is the answer."
          }
        ];
      
        const [activeIndex, setActiveIndex] = useState<number>(0);
        const [visible, setVisible] = useState(false);
        const ref = useRef<HTMLDivElement | null>(null);
  
        
          useEffect(() => {
            const obs = new IntersectionObserver(
              ([e]) => {
                if (e.isIntersecting) setVisible(true);
              },
              { threshold: 0.12 }
            );
        
            if (ref.current) obs.observe(ref.current);
            return () => obs.disconnect();
          }, []);
        
          const [active, setActive] = useState("light");
    
            const trackRef = useRef<HTMLDivElement | null>(null);
            const [paused, setPaused] = useState(false);
          
    
        // const items = [...items, ...items];
          
            useEffect(() => {
              const track = trackRef.current;
              if (!track) return;
          
              let raf = 0;
              let x = 0;
          
              const speed = 0.65;
          
              const animate = () => {
                if (!paused) {
                  x -= speed;
          
                  const halfWidth = track.scrollWidth / 2;
                  if (Math.abs(x) >= halfWidth) x = 0;
          
                  track.style.transform = `translateX(${x}px)`;
                }
          
                raf = requestAnimationFrame(animate);
              };
          
              raf = requestAnimationFrame(animate);
          
              return () => cancelAnimationFrame(raf);
            }, [paused]);
    
             useStyles();
    
      const headerRef = useRef<HTMLDivElement>(null);
      const gridRef = useRef<HTMLDivElement>(null);
  
    const [activeRow, setActiveRow] = useState<number | null>(null);

        interface Role {
            num: string;
            icon: LucideIcon;
            title: string;
            desc: string;
        }
    
        const ROLES: Role[] = [
        { num: "01", icon: Key  ,
          title: "End-to-End Encryption", desc: "With SpaceByte online cloud storage, your files stay protected using AES-256 encryption for stored data and TLS 1.3 for secure transfers, giving you strong, reliable privacy at every step." },
        { num: "02", icon: Share2 ,
          title: " File Sharing",
          desc: "Share your files easily with secure cloud storage, using safe links and simple access controls, so you stay in charge of who can view or download your data.", },
        { num: "03", icon: Database ,
          title: "No File Size Limits",
          desc: "Upload and share large files with unlimited cloud storage without worrying about size restrictions, making it easier to handle videos, backups, and heavy project files.",
        },
        { num: "04", icon: Wifi ,
          title: "No Bandwidth Limit",
          desc: "Transfer and access your files with unlimited bandwidth so you can upload, download, and share data freely without slowdowns or usage restrictions.",
        },
        { num: "05", icon: ShieldCheck ,
          title: "Permission Control",
          desc: "Manage who can view, edit, or share your files with advanced access control, giving you full control over file permissions and keeping your data secure.",
        },
        ];

      const GLOBAL_CSS = `
        :root {
          --bg: #F5F2EC; --white: #FDFCFA; --ink: #1C1B18; --ink2: #3A3830;
          --muted: #8C8880; --line: rgba(28,27,24,0.12); --mint: #2DC88A;
          --mint-dim: rgba(45,200,138,0.12); --rust: #E05A2B; --sky: #1A6FFF;
        }
        *, *::before, *::after { box-sizing: border-box; margin: 0; padding: 0; }
        html { scroll-behavior: smooth; }

        .sb-roles {
          display: grid;
          grid-template-columns: 280px 1fr;
          border-bottom: 2px solid #1E3A8A;
          border-top: 2px solid #1E3A8A;
          min-height: 420px;
        }
        .sb-roles-left {
          border-right: 2px solid #1E3A8A;
          padding: 3.5rem 2.5rem;
          background: #1E3A8A;
          color: var(--bg);
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .sb-roles-eyebrow {
          font-size: .7rem; font-weight: 700; text-transform: uppercase;
          letter-spacing: .14em; color: #00c2ff; margin-bottom: 1.2rem;
        }
        .sb-roles-left h2 {
          font-size: 2rem; font-weight: 900; line-height: 1.1;
          letter-spacing: -.5px; color: #FDFCFA;
        }
        .sb-roles-left p {
          font-size: .85rem; color: rgba(253,252,250,0.55);
          margin-top: 1rem; line-height: 1.65;
        }
        .sb-roles-left a { color: #00c6ff; }
        .sb-rl-count {
          font-size: 3.5rem; font-weight: 900;
          color: #00c2ff; line-height: 1;
        }
        .sb-rl-count span {
          display: block; font-size: .78rem; font-weight: 500;
          color: rgba(253,252,250,0.4); letter-spacing: .1em;
          text-transform: uppercase; margin-top: .3rem;
        }
        .sb-roles-list { display: flex; flex-direction: column; background: #f5f8ff; }
        .sb-role-row {
          display: flex; align-items: center;
          border-bottom: 1px solid var(--line);
          cursor: pointer; transition: background .2s;
        }
        .sb-role-row:last-child { border-bottom: none; }
        .sb-role-row:hover { background: #e3eaf9; }
        .sb-role-row:hover .sb-rr-arrow { opacity: 1; transform: translateX(0); }
        .sb-rr-num {
          width: 60px; flex-shrink: 0; border-right: 1px solid var(--line);
          text-align: center; padding: 1.8rem 0; font-size: .75rem;
          font-weight: 700; text-transform: uppercase;
          letter-spacing: .08em; color: var(--muted);
        }
        .sb-rr-icon {
          width: 64px; flex-shrink: 0; border-right: 1px solid var(--line);
          display: flex; align-items: center; justify-content: center;
          padding: 1.8rem 0; font-size: 1.4rem;
        }
        .sb-rr-body { flex: 1; padding: 1.8rem 2rem; min-width: 0; }
        .sb-rr-title {
          font-size: .95rem; font-weight: 700;
          color: var(--ink); margin-bottom: .25rem;
        }
        .sb-rr-desc { font-size: .8rem; color: var(--muted); line-height: 1.5; }
        .sb-rr-arrow {
          padding: 0 1.5rem; font-size: 1.1rem; color: #3B82F6;
          opacity: 0; transform: translateX(-6px);
          transition: opacity .2s, transform .2s; flex-shrink: 0;
        }

        .reveal { opacity: 0; transform: translateY(24px); transition: opacity .6s ease, transform .6s ease; }
        .reveal.visible { opacity: 1; transform: translateY(0); }

        @media (max-width: 860px) {
          .sb-roles { grid-template-columns: 1fr; }
          .sb-roles-left {
            border-right: none;
            border-bottom: 2px solid #1E3A8A;
            padding: 2.5rem 2rem;
            flex-direction: row;
            flex-wrap: wrap;
            align-items: flex-start;
            gap: 1.5rem;
            min-height: unset;
          }
          .sb-roles-left-text { flex: 1; min-width: 200px; }
          .sb-rl-count { text-align: right; }
        }
        @media (max-width: 560px) {
          .sb-roles-left {
            flex-direction: column;
            padding: 2rem 1.5rem;
          }
          .sb-rl-count { text-align: left; }
          .sb-roles-left h2 { font-size: 1.5rem; }
          .sb-rr-num { width: 42px; font-size: .65rem; }
          .sb-rr-icon { width: 48px; }
          .sb-rr-body { padding: 1.2rem 1rem; }
          .sb-rr-arrow { display: none; }
        }
      `;
              function useReveal() {
                useEffect(() => {
                  const obs = new IntersectionObserver(
                    (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("visible"); }),
                    { threshold: 0.08 }
                  );
                  document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
                  return () => obs.disconnect();
                }, []);
              }
        
              const [openFaq, setOpenFaq] = useState<number>(0);
                const styleInjected = useRef(false);
        
                useEffect(() => {
                  if (styleInjected.current) return;
                  styleInjected.current = true;
                  const tag = document.createElement("style");
                  tag.innerHTML = GLOBAL_CSS;
                  document.head.appendChild(tag);
                }, []);
              
                useReveal();

      return (
        <Fragment>
    
          <Helmet>
            <title>Secure & Flexible Google Drive Alternative | SpaceByte</title>
            <meta
              name="description"
              content="Tired of Google Drive limits? Switch to SpaceByte for secure cloud storage, faster uploads, and more control over your files."
            />
            <meta name="keywords" content="Google Drive Alternative" />
            <link rel="canonical" href="https://spacebyte.in/smart-google-drive-alternative" />
          </Helmet>
    
          <LandingNavbar
            color="transparent"
            className="fixed top-0 z-50 w-full flex-shrink-0 border-none bg-light-primary  shadow-lg"
            menuPosition="homepage-navbar"
          />
          
          <section className=" relative overflow-hidden !bg-gradient-to-r !from-[#0072ff]/8 !to-[#00c6ff]/8 py-24 md:py-32">
            <div className="absolute inset-0 opacity-5">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="#1E3A8A" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#grid)" />
              </svg>
            </div>
            <div
              className={`landing-container z-10 flex flex-col items-center justify-between pb-40 pt-100 lg:flex-row`}
            >
              <div className="mx-auto w-full max-w-6xl px-4 text-center">
    
                {/* Heading */}
                <h1 className="font-archivo text-[40px] md:text-[60px] font-bold leading-[1.2] tracking-[-0.02em] text-[#1f2937]">
                  Smart Google Drive Alternative {" "} 
                 <br />     
                 <span className="color-primary-gradient">for Secure Cloud Storage </span>
                  
    
                </h1>
    
                {/* Sub heading */}
                <p className="mx-auto mt-30 max-w-3xl font-inter text-[18px] md:text-[20px]  text-[#6b7280]">
                    Google Drive works well at first, but storage limits, basic sharing, and limited privacy control often push users to switch to a more flexible Google Drive alternative.
                </p>
    
              <div className="my-36 pb-20 flex flex-col items-center justify-center gap-6 sm:flex-row">
                <a
                  href="/register"
                  className="inline-flex items-center justify-center 
                  px-26 py-10 
                  text-white font-bold
                  bg-gradient-to-r from-[#0072ff] to-[#00c6ff]
                  shadow-lg transition-all duration-300
                  hover:from-[#0059d6] hover:to-[#00aaff]
                  hover:shadow-2xl hover:-translate-y-1"
                  style={{
                  borderRadius: "12px"
                }}
                >
                  Get 25 GB FREE
                </a>
                <a
                  href="/pricing"
                  className="inline-flex items-center justify-center
                  px-36 py-8 font-bold
                  text-[#0072ff]
                  relative transition-all duration-300
                  hover:-translate-y-1 hover:shadow-lg "
                  style={{
                    borderRadius: "12px",
                    background: "linear-gradient(#e5f5fb, #e5f5fb) padding-box, linear-gradient(90deg, #0072ff, #00c6ff) border-box",
                    border: "2px solid transparent"
                  }}
                  >
                  View Pricing
                </a>
              </div>
              </div>
            </div>
          </section>  

          <section className="py-24 md:py-32 bg-gradient-to-br from-[#F8FAFC] to-white relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-5 landing-container z-10">
              <div className="absolute top-10 left-10 w-72 h-72 bg-[#3B82F6] rounded-full blur-3xl"></div>
              <div className="absolute bottom-10 right-10 w-96 h-96 bg-[#06B6D4] rounded-full blur-3xl"></div>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 my-30 md:my-50 sm:px-6 lg:px-8 relative z-10">
              {/* Section Header */}
              <motion.div
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center mb-16"
              >
    
                <h2 className="text-3xl sm:text-4xl lg:text-5xl font-archivo font-bold text-[#111827] mb-10">
                  Start Your Cloud Storage in <span className="color-primary-gradient">Three Steps</span>{" "}
    
                </h2>
                <p className="text-lg text-[#6B7280] max-w-2xl mx-auto pb-10 font-archivo">
                  Start storing and sharing your files securely in minutes
                </p>
              </motion.div>
    
              {/* Steps */}
              <div className="grid md:grid-cols-3 gap-8 md:gap-12 relative landing-container">
                {/* Connecting Line */}
                <div className="hidden md:block absolute top-90 left-0 right-0 h-2 bg-gradient-to-r from-[#3B82F6] via-[#60A5FA] to-[#06B6D4] opacity-30"></div>
    
                {steps.map((step, index) => (
                  <motion.div
                    key={index}
                    initial={{ opacity: 0, y: 30 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: index * 0.2 }}
                    className="relative"
                  >
                    <div className="flex flex-col items-center text-center">
                      {/* Icon Circle */}
                      <div className="relative mb-6">
                        <div className="w-80 h-80 bg-gradient-to-br from-[#1E3A8A] to-[#3B82F6] rounded-full flex items-center justify-center relative z-10 shadow-lg">
                          <step.icon className="w-40 h-40 text-white" />
                        </div>
                        <div className="absolute -top-2 -right-10  w-40 h-40 bg-white rounded-full flex items-center justify-center border-2 border-[#3B82F6] z-20">
                          <span className="text-[#1E3A8A] font-bold text-sm">{step.number}</span>
                        </div>
                      </div>
    
                      {/* Content */}
                      <h3 className="text-2xl font-semibold font-archivo text-[#111827] my-20">
                        {step.title}
                      </h3>
                      <p className="text-[#6B7280] font-archivo max-w-xs">
                        {step.description}
                      </p>
                    </div>
                  </motion.div>
                ))}
              </div>
    
              {/* Animated Line */}
              <motion.div
                initial={{ scaleX: 0 }}
                whileInView={{ scaleX: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 1.5, delay: 0.5 }}
                className=" hidden md:block absolute top-[260px] left-[25%] right-[25%] h-3 bg-gradient-to-r from-[#3B82F6] to-[#06B6D4] rounded-full origin-left"
              ></motion.div>
            </div>
          </section>

          <section className="relative overflow-hidden bg-[#f5f8ff]  py-24 md:py-32">
          <div className="landing-container z-10 mx-auto px-4">

            {/* Heading */}
            <div className="text-center mb-14">
                <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl py-16 md:py-24">
                Why Users Are Moving Away   <span className="color-primary-gradient"> from Google Drive</span>              
                </h2>
            </div>

        <Swiper
        modules={[Pagination]}
        spaceBetween={24}
        pagination={{
            clickable: true,
            el: ".custom-pagination",
        }}
        breakpoints={{
            0: { slidesPerView: 1 },
            768: { slidesPerView: 2 },
            1024: { slidesPerView: 3 },
        }}
        style={{ paddingBottom: "30px" }}
        >
        {cards.map((card, index) => (
            <SwiperSlide key={index} style={{ display: "flex", height: "auto" }}>
            
            <div
                className="group bg-white rounded-2xl 
                        p-14 md:p-16 lg:p-18
                        border border-gray-200
                        hover:border-[#3B82F6]/40 hover:shadow-xl
                        transition-all duration-300
                        flex flex-col flex-1 min-h-[250px]"
            >
                {/* ICON */}
                <div
                className={`w-40 h-40 md:w-50 md:h-50 
                            bg-gradient-to-br ${card.color}
                            rounded-xl flex items-center justify-center 
                            mb-12 transition-transform duration-300 
                            group-hover:scale-110`}
                >
                {card.icon}
                </div>

                {/* TITLE */}
                <h3 className="text-xl md:text-2xl font-semibold text-gray-900 mb-8">
                {card.title}
                </h3>

                {/* DESC */}
                <p className="color-gray font-base text-sm  leading-relaxed flex-grow">
                {card.desc}
                </p>
            </div>

            </SwiperSlide>
        ))}

        {/* 👇 Custom Pagination Below Cards */}
        <div
            className="custom-pagination"
            style={{
            marginTop: "40px",
            position: "relative",
            textAlign: "center",
            }}
        />
        </Swiper>
        </div>
          </section>

      <section
        id="Pricing"
        className="pricing-section relative overflow-hidden bg-white py-40 text-black lg:py-50"
      >
        <div className="landing-container z-10">
          <div className="mx-auto max-w-xl space-y-16 text-center">
            <h2 className="animate-fade-down font-archivo text-3xl font-bold md:text-4xl lg:text-5xl">
              Affordable <span className="color-primary-gradient"> Cloud Storage Pricing </span> Plans
            </h2>
            <p className="color-gray font-inter animate-fade-down">
              Get affordable pricing with no hidden fees, encrypted cloud storage,
              and fast, seamless access to your files anytime, anywhere.
            </p>
          </div>

          <div className="my-40 flex flex-col md:flex-row justify-center items-center gap-16">
            <BillingCycleRadio
              products={query.data?.products}
              selectedCycle={selectedCycle}
              onChange={setSelectedCycle}
              className="input-radio animate-fade-up flex justify-center items-center flex-wrap"
              size="lg"
            />
          </div>

          <PricingTable
            selectedCycle={selectedCycle}
            productLoader="pricingPage"
            className="animate-fade-down"
          />

          {/* Premium Section */}
          <div
            className="premium-bg animate-fade-down bg-light-primary relative mt-40 flex flex-col items-center justify-between space-y-8 overflow-hidden rounded-2xl border-primary p-16 shadow-lg md:flex-row md:space-y-0 md:p-32"
            style={{
              backgroundImage:
                "url('/images/LandingImg/ctamask.png'), url('/images/LandingImg/ctashape.png')",
              backgroundSize: 'contain, contain',
              backgroundRepeat: 'no-repeat, no-repeat',
              backgroundPosition: 'left center, right center',
            }}
          >
            {/* Premium Tag */}
            <div className="font-archivo absolute -left-54 top-16 w-160 rotate-[-45deg] transform rounded bg-warning text-center text-sm font-medium text-black md:-left-56 lg:-left-50 lg:top-20">
              Premium
            </div>

            {/* Icon and Text */}
            <div className="flex flex-col items-center gap-8 space-y-8 md:flex-row md:space-x-8 md:space-y-0">
              <img
                src="/images/LandingImg/cta-icon.webp"
                className="color-primary rounded-lg bg-white p-16"
              />
              <div className="text-center md:text-left">
                <h2 className="font-archivo text-3xl font-bold">
                  5 TB or More?
                </h2>
                <span className="color-primary font-archivo text-2xl font-semibold">
                  ₹0.15/GB{' '}
                  <span className="text-lg font-normal text-black">
                    /Monthly
                  </span>
                </span>
                <p className="font-inter mt-8 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> 100% Safe & Secure with
                  End-to-End Encryption
                </p>
                <p className="font-inter mt-1 flex items-start justify-center gap-4 text-sm md:justify-start">
                  <CheckCircleOutlineIcon size="sm" /> Calculate the cost or
                  Reach out to us
                </p>
              </div>
            </div>

            {/* Buttons */}
            <div className="flex flex-row flex-wrap gap-8 sm:flex-col lg:flex-row justify-center">
              <div className="flex justify-center">
                {CalculateDialogTrigger()}
              </div>

              <div className="mt-0 flex justify-center">
                <a href="/contact" className="btn bg-[#f9fafb] border-2 border-[#0072ff] text-black hover:bg-[#0072ff] hover:text-white">
                  <span>Contact Us</span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

          <ComparisonSection />

          <section className="py-24 md:py-32 relative overflow-hidden bg-white">
      <div className="sb-roles landing-container z-10 bg-[#f5f8ff]" id="roles">
        <div className="sb-roles-left">
          <div>
            {/* <div className="sb-roles-eyebrow">Who It&apos;s For</div> */}
            <h2>Secure Cloud Storage & Easy File Sharing</h2>
            <p>
                  Store your files securely with{" "}
                    <a
                      href="/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-[#00c6ff] hover:underline"
                    >
                      SpaceByte Cloud Storage
                    </a>
                    , using strong encryption and easy access from any device, without worrying about storage limits or losing important data.
                  </p>
          </div>
          <div className="sb-rl-count">
            5<br />
            <span style={{ fontFamily: "'Outfit',sans-serif", fontSize: ".85rem", fontWeight: 500, color: "rgba(253,252,250,0.45)", letterSpacing: ".08em", textTransform: "uppercase" }}>
              Roles Covered
            </span>
          </div>
        </div>
        <div className="sb-roles-list">
          {ROLES.map((r) => (
            <div className="sb-role-row reveal" key={r.num}>
              <div className="sb-rr-num">{r.num}</div>
              <div className="sb-rr-icon"><r.icon size={28} strokeWidth={2} className="text-[#1E3A8A]" /></div>
              <div className="sb-rr-body">
                <div className="sb-rr-title">{r.title}</div>
                <div className="sb-rr-desc">{r.desc}</div>
              </div>
              <div className="sb-rr-arrow">→</div>
            </div>
          ))}
        </div>
      </div>
          </section>
                

    
          <section className="w-full px-4 md:px-10 py-40 bg-white relative overflow-hidden">
            <div className="landing-container min-h-[280px] md:min-h-[380px] flex items-center justify-center relative rounded-2xl overflow-hidden">
    
              {/* Video Background */}
              <video
                className="absolute inset-0 w-full h-full object-cover"
                src="/images/LandingImg/video.mp4"
                autoPlay
                loop
                muted
                playsInline
              />
    
              {/* Dark Overlay */}
              <div className="absolute inset-0 bg-black/60" />
    
              {/* Gradient Light */}
              <div className="absolute inset-0 bg-gradient-to-r from-cyan-500/20 via-transparent to-blue-600/20" />
    
              {/* Content */}
              <div className="relative z-10 text-center max-w-4xl px-4">
                <h2 className="text-white text-3xl md:text-5xl font-semibold">
                  Your Data, Your Control, Your Cloud
                </h2>
    
                <p className="text-white/80 text-base md:text-lg mt-20">
                  A smarter cloud storage platform that gives you complete control over your data, file sharing, and digital privacy.
    
                </p>
    
                <div className="mt-20">
                  <a href="/contact" className="btn bg-white text-black px-20 py-10 rounded-xl font-medium hover:scale-105 transition">
                    <span>Contact Us</span>
                  </a>
                </div>
              </div>
    
            </div>
          </section>
          
          <section id="faq" className="bg-[#f5f8ff] relative overflow-hidden py-24 text-black lg:py-32">
            <div className="landing-container z-10">
              <div className="section-wrapper">
                <div className="section-inner">
                  {/* LEFT PANEL */}
                  <div className="left-panel">
                    <div className="badge font-archivo">
                      <svg width="10" height="10" viewBox="0 0 10 10" fill="none">
                        <circle cx="5" cy="5" r="5" fill="#38bdf8" />
                      </svg>
                      SpaceByte Cloud
                    </div>
    
                    <h2 className="left-title font-archivo">
                      Best Cloud Storage <br />
                      Secure, Fast and  <br />
                      Reliable
                    </h2>
    
                    <p className="left-sub font-archivo">
                      Everything you need to store, share, and access your files anytime, anywhere.
                    </p>
    
                    <div className="illustration">
                      <div className="illus-card">
                        <div className="illus-row">
                          <div className="illus-icon ic-blue">☁️</div>
                          <div className="illus-text font-archivo">
                            <strong>My Storage</strong>
                            <span>18.3 GB used of 25 GB</span>
                            <div className="illus-bar">
                              <div className="illus-bar-fill" style={{ width: "73%" }} />
                            </div>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-sky">📁</div>
                          <div className="illus-text font-archivo">
                            <strong>Shared Folders</strong>
                            <span>12 folders · 3 collaborators</span>
                          </div>
                        </div>
    
                        <div className="illus-row">
                          <div className="illus-icon ic-white">🔒</div>
                          <div className="illus-text">
                            <strong>End-to-End Encrypted</strong>
                            <span>All files secured in transit</span>
                          </div>
                        </div>
    
                        <div className="stats-row">
                          <div className="stat-chip">
                            <strong>25 GB</strong>
                            <span>Free Storage</span>
                          </div>
                          <div className="stat-chip">
                            <strong>99.9%</strong>
                            <span>Uptime</span>
                          </div>
                          <div className="stat-chip">
                            <strong>24/7</strong>
                            <span>Support</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
    
                  {/* RIGHT PANEL */}
                  <div className="right-panel">
                    <p className="section-tag">Help Center</p>
    
                    <h2 className="section-title">
                      Quick Reference <br />
                      Guide
                    </h2>
    
                    <p className="section-desc">
                      Find answers to the most common questions about SpaceByte Cloud Storage.
                    </p>
    
                    <div className="accordion">
                      {faqData.map((item, index) => (
                        <div
                          key={index}
                          className={`acc-item ${openIndex === index ? "open" : ""}`}
                        >
                          <button className="acc-header" onClick={() => toggle(index)}>
                            <div className="acc-num">
                              {String(index + 1).padStart(2, "0")}
                            </div>
    
                            <span className="acc-label">{item.question}</span>
    
                            <div className="acc-chevron">
                              <svg viewBox="0 0 24 24" fill="none">
                                <polyline points="6 9 12 15 18 9" />
                              </svg>
                            </div>
                          </button>
    
                          <div className="acc-body">
                            <div
                              className="acc-body-inner"
                              dangerouslySetInnerHTML={{ __html: item.answer }}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
    
          <section className="py-20 md:py-32 bg-gradient-to-br from-[#1E3A8A] via-[#3B82F6] to-[#60A5FA] relative overflow-hidden">
            {/* Animated Background */}
            <div className="absolute inset-0 landing-container z-10">
              <div className="absolute top-0 left-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse"></div>
              <div className="absolute bottom-0 right-0 w-96 h-96 bg-white/10 rounded-full blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
            </div>
    
            {/* Grid Pattern */}
            <div className="absolute inset-0 opacity-10">
              <svg className="w-full h-full" xmlns="http://www.w3.org/2000/svg">
                <defs>
                  <pattern id="cta-grid" width="40" height="40" patternUnits="userSpaceOnUse">
                    <path d="M 40 0 L 0 0 0 40" fill="none" stroke="white" strokeWidth="1" />
                  </pattern>
                </defs>
                <rect width="100%" height="100%" fill="url(#cta-grid)" />
              </svg>
            </div>
    
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-40 relative z-10">
              <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                className="text-center"
              >
                {/* Icon */}
                <motion.div
                  initial={{ scale: 0 }}
                  whileInView={{ scale: 1 }}
                  viewport={{ once: true }}
                  transition={{ type: 'spring', delay: 0.2 }}
                  className="inline-flex items-center justify-center w-60 h-60 bg-white/20 backdrop-blur-sm rounded-2xl mb-12"
                >
                  <Sparkles className="w-30 h-30 text-white" />
                </motion.div>
    
                {/* Heading */}
                <motion.h2
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.3 }}
                  className="text-3xl sm:text-4xl lg:text-5xl xl:text-6xl font-bold text-white"
                >
                  Ready to Secure Your Data?
                </motion.h2>
    
                {/* Subheading */}
                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.4 }}
                  className="text-lg sm:text-xl text-white/90 my-16 max-w-2xl mx-auto"
                >
                  Join thousands of businesses trusting secure cloud storage to protect critical data.
    
                </motion.p>
    
                {/* CTA Button */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.5 }}
                  className="flex flex-col sm:flex-row gap-10 justify-center items-center"
                >
                  <a href="/register" className="group bg-white text-[#1E3A8A] px-16 py-14 rounded-xl font-semibold hover:bg-gray-100 transition-all hover:shadow-2xl hover:shadow-white/20 transform hover:-translate-y-1 flex items-center gap-2 btn">
                    Get 25 GB FREE - No Card Needed
                  </a>
    
                </motion.div>
    
                {/* Trust Badges */}
                <motion.div
                  initial={{ opacity: 0 }}
                  whileInView={{ opacity: 1 }}
                  viewport={{ once: true }}
                  transition={{ delay: 0.6 }}
                  className="mt-20 flex flex-wrap justify-center items-center gap-8 text-white/80 text-sm"
                >
    
                </motion.div>
              </motion.div>
            </div>
          </section>
    
          <footer className="Footer-section relative overflow-hidden bg-[#0F172A] text-white pt-16 pb-8">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
              {/* Main Footer Content */}
              <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-6 gap-8 mb-12">
                {/* Brand Column */}
                <div className="col-span-2 md:col-span-4 lg:col-span-2">
                  <div className="space-y-4 mr-12 padding-logo padding-top">
                    <a href="https://spacebyte.in/" className="flex-shrink-0">
                      <img
                        src="/images/logo-light.png"
                        alt="Logo"
                        className="site-logo"
                      />
                    </a>
                    <div>
                      <p className="font-medium pt-8 pb-10">SPACEBYTE CLOUD STORAGE</p>
                      <p className="pb-10 pt-3 flex items-center gap-2">
                        311, Maruti Plaza, Sardar Patel Chowk, Krishnanagar, Ahmedabad, Gujarat,
                        India - 382345</p>
                  <p className="pb-10 pt-3 flex items-center gap-2">
                    Mo. +91 97257 71457
                  </p>
                    </div>
                    <div>
                      <p className="font-bold text-base pb-10 pt-3">FOLLOW US FOR 'SPACEBYTE.IN'</p>
                      <div className="flex gap-4 mt-3 logg mb-10">
                        <ul className="flex space-x-16 pt-3 pr-10">
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.facebook.com/profile.php?id=61567307277313&mibextid=ZbWKwL">
                              <FacebookIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://www.instagram.com/spacebyte.in?igsh=MmZidnprMXZtbTho ">
                              <InstagramIcon className="text-white" />
                            </a>
                          </li>
                          <li className="bg-light rounded-lg p-8">
                            <a href="https://youtube.com/@spacebytecloudstorage?si=lt2mfOM7kSaN3g6B">
                              <YoutubeIcon className="text-white" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
    
                {/* Product Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start ">Product</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#features" className="hover:text-white transition-colors text-start">
                        Features
                      </a>
                    </li>
                    <li>
                      <a href="/Pricing" className="hover:text-white transition-colors">
                        Pricing
                      </a>
                    </li>
                    <li>
                      <a href="#security" className="hover:text-white transition-colors">
                        Security
                      </a>
                    </li>
                    <li>
                    </li>
                  </ul>
                </div>
    
                {/* Company Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Company</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/about-us" className="hover:text-white transition-colors">
                        About Us
                      </a>
                    </li>
                    <li>
                      <a href="/pages/articles" className="hover:text-white transition-colors">
                        Articles
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Contact Us
                      </a>
                    </li>
                  </ul>
                </div>
    
                {/* Resources Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h2 className="font-semibold text-xl mb-10  text-start">Resources</h2>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="#faq" className="hover:text-white transition-colors">
                        FAQs
                      </a>
                    </li>
                    <li>
                      <a href="/contact" className="hover:text-white transition-colors">
                        Help Center
                      </a>
                    </li>
                    {/* <li>
                    <a href="https://spacebyte.in/api-docs" className="hover:text-white transition-colors">
                      Developers
                    </a>
                  </li> */}
                <li>
                  <a href="/storage/sitemaps/sitemap-index.xml" className="hover:text-white transition-colors">
                    Sitemap
                  </a>
                </li>
                  </ul>
                </div>
    
                {/* Legal Column */}
                <div className='py-8 md:py-20 px-30'>
                  <h3 className="font-semibold text-xl mb-10  text-start">Legal</h3>
                  <ul className="space-y-3 text-sm text-gray-400 text-start">
                    <li>
                      <a href="/pages/privacy-policy" className="hover:text-white transition-colors">
                        Privacy Policy
                      </a>
                    </li>
                    <li>
                      <a href="/pages/terms-of-service" className="hover:text-white transition-colors">
                        Terms of Service
                      </a>
                    </li>
                  </ul>
                </div>
              </div>
    
              {/* Bottom Bar */}
              <div className="font-inter border-t border-t-primary/80 py-16 text-center mt-5">
                <p className="text-sm">
                  Copyright © {new Date().getFullYear()}{' '}
                  <a href="/login" className="color-primary-gradient">
                    SpaceByte Cloud Storage
                  </a>
                  , All Rights Reserved
                </p>
              </div>
            </div>
          </footer>
        </Fragment>
      );
    }
    
    function CalculateDialogTrigger() {
      const form = useForm<ContactPagePayload>({
        defaultValues: {
          message: '', // Initialize message field
        },
      });
      const [isOpen, setIsOpen] = useState(false);
      const [isContactDialogOpen, setIsContactDialogOpen] = useState(false);
      const submitForm = useSubmitContactForm(form);
      const { verify, isVerifying } = useRecaptcha('contact');
    
      return (
        <>
          <DialogTrigger type="modal" isOpen={isOpen} onOpenChange={setIsOpen}>
            <button className="btn w-full rounded-lg !text-white font-semibold
                            !bg-gradient-to-r !from-[#0072ff] !to-[#00c6ff]  shadow-lg
                            hover:shadow-xl transition">
              <span>Get Quote</span>
            </button>
            <Dialog className="w-full max-w-lg rounded-xl p-6">
              <DialogHeader
                className="font-archivo text-2xl font-semibold"
                showDivider
              >
                <Trans message="Storage Cost Calculator" />
              </DialogHeader>
              <DialogBody>
                <div className="font-inter flex items-center justify-center">
                  Enter the storage size (whole number greater than **5 TB**) to
                  calculate your monthly cost.
                </div>
                <Form
                  form={form}
                  className="mt-4 flex flex-col items-center text-center"
                  onSubmit={async value => {
                    calculateCost(value);
                  }}
                >
                  <FormTextField
                    label={<Trans message="Enter Storage in TB" />}
                    name="tb"
                    required
                    type="number"
                    className="mb-6 w-full rounded-lg p-2"
                  />
                  <div className="text-red-500 text-md" id="errorMsg"></div>
                  <div className="text-blue-500 text-md" id="resultOutput"></div>
                  <div className="mt-6 flex w-full justify-between gap-4">
                    <button className="btn-warning mt-16" type="submit">
                      Calculate
                    </button>
                    <Button
                      color="positive"
                      variant="outline"
                      className="mt-16 rounded-lg"
                      type="button"
                      onClick={() => {
                        const resultOutput =
                          document.getElementById('resultOutput')?.textContent;
                        form.setValue('message', resultOutput || ''); // Set the value of message field
                        setIsOpen(false); // Close current dialog
                        setIsContactDialogOpen(true); // Open Contact Us dialog
                      }}
                    >
                      Contact Us
                    </Button>
                  </div>
                </Form>
              </DialogBody>
            </Dialog>
          </DialogTrigger>
    
          {isContactDialogOpen && (
            <DialogTrigger
              type="modal"
              isOpen={isContactDialogOpen}
              onOpenChange={setIsContactDialogOpen}
            >
              <Dialog className="w-full max-w-lg rounded-xl p-6">
                <DialogHeader
                  className="font-archivo text-2xl font-semibold"
                  showDivider
                >
                  <Trans message="Contact Us" />
                </DialogHeader>
                <DialogBody>
                  {submitForm.isPending ? (
                    <FullPageLoader />
                  ) : (
                    <Form
                      form={form}
                      className="flex flex-col gap-4"
                      onSubmit={async value => {
                        const isValid = await verify();
                        if (isValid) {
                          submitForm.mutate(value, {
                            onSuccess: () => {
                              setIsContactDialogOpen(false); // Close the dialog on success
                            },
                          });
                        }
                      }}
                    >
                      <FormTextField
                        label={<Trans message="Name" />}
                        name="name"
                        required
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Email" />}
                        name="email"
                        required
                        type="email"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Mobile Number" />}
                        name="mobileNumber"
                        required
                        type="number"
                        className="rounded-lg p-2"
                      />
                      <FormTextField
                        label={<Trans message="Message" />}
                        name="message"
                        required
                        inputElementType="textarea"
                        className="rounded-lg p-2"
                        rows={5}
                      />
    
                      <div className="mt-4 flex w-full justify-between gap-4">
                        <Button
                          variant="flat"
                          onClick={() => setIsContactDialogOpen(false)}
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Back" />
                        </Button>
                        <Button
                          type="submit"
                          variant="flat"
                          color="primary"
                          className="rounded-lg px-4 py-2 text-lg"
                        >
                          <Trans message="Send Message" />
                        </Button>
                      </div>
                    </Form>
                  )}
                </DialogBody>
              </Dialog>
            </DialogTrigger>
          )}
        </>
      );
    }
    
    function calculateCost({ tb }: any) {
      const tbInput: any = tb;
      const errorMsg: any = document.getElementById('errorMsg');
      const resultOutput: any = document.getElementById('resultOutput');
    
      // Reset messages
      errorMsg.textContent = '';
      resultOutput.textContent = '';
    
      // Validation: Ensure input is a positive integer and greater than 5
      if (!/^\d+$/.test(tbInput)) {
        errorMsg.textContent = 'Error: Storage must be a whole number!';
        return;
      }
    
      const tbValue = parseInt(tbInput, 10);
    
      if (tbValue <= 5) {
        errorMsg.textContent = 'Error: Storage must be greater than 5 TB!';
        return;
      }
    
      // Conversion and cost calculation
      const gbStorage = tbValue * 1024; // Convert TB to GB
      const cost = gbStorage * 0.15; // Calculate cost
    
      // Display result
      resultOutput.innerHTML = `
          Storage: <strong>${tbValue.toLocaleString()} TB</strong><br>
          Total Cost: <strong>₹${cost.toFixed(2)}/month</strong><br>
          GST and Convenience Fee Extra**
      `;
    }
    
    function ReviewCard({
      item,
      isActive,
    }: {
      item: any;
      isActive: boolean;
    }) {
      const { name, role, avatar, review, accent, light, rating } = item;
      
      // Extract the first letter of the name
      const initial = name?.charAt(0).toUpperCase() || "U";
    
      return (
        <div
          className={[
            "relative flex-shrink-0 overflow-hidden m-10 rounded-[28px] border-[1.5px] p-[clamp(24px,3.5vw,42px)] transition-all duration-500 flex flex-col justify-between",
            isActive ? "translate-y-[-4px] scale-[1.015]" : "scale-[0.97]",
          ].join(" ")}
          style={{
            minWidth: "clamp(270px, 42vw, 450px)",
            maxWidth: "clamp(270px, 42vw, 450px)",
            background: isActive
              ? `linear-gradient(150deg, ${light} 0%, white 100%)`
              : `linear-gradient(150deg, ${light}88 0%, #f8fafc 100%)`,
            borderColor: isActive ? `${accent}50` : "#e2e8f0",
            boxShadow: isActive
              ? `0 24px 60px ${accent}1a, 0 4px 16px ${accent}10`
              : "0 2px 12px rgba(0,0,0,0.05)",
            opacity: isActive ? 1 : 0.68,
          }}
        >
          <div>
            {/* Rating Section */}
            <div className="flex items-center justify-between mb-6">
              <div className="flex gap-1">
                {[...Array(5)].map((_, i) => (
                  <span key={i} style={{ color: i < rating ? accent : "#cbd5e1" }} className="text-[18px]">
                    ★
                  </span>
                ))}
              </div>
              {/* Subtle Quote Mark */}
              <span className="font-serif text-[60px] leading-none opacity-10 absolute right-8 top-6" style={{ color: accent }}>
                “
              </span>
            </div>
    
            <p className="font-archivo text-[clamp(14px,1.15vw,16px)] font-medium leading-[1.7] mb-8 text-[#334155]">
              "{review}"
            </p>
          </div>
    
          <div className="flex items-center gap-10">
            {/* AVATAR / INITIAL BOX */}
            <div 
              className="flex h-50 w-50 shrink-0 items-center justify-center rounded-full border-2 font-archivo text-[20px] font-bold"
              style={{ 
                borderColor: `${accent}40`,
                background: isActive ? `${accent}15` : "#f1f5f9",
                color: accent 
              }}
            >
              {avatar ? (
                <img src={avatar} alt={name} className="h-full w-full object-cover rounded-full" />
              ) : (
                <span>{initial}</span> 
              )}
            </div>
    
            <div className="overflow-hidden ">
              <h4 className="truncate font-archivo text-[17px] font-bold text-[#0f172a] leading-tight">
                {name}
              </h4>
              <p className="truncate text-[13px] font-semibold" style={{ color: accent }}>
                {role}
              </p>
            </div>
          </div>
    
          <div
            className="absolute bottom-0 left-0 h-[3px] rounded-bl-[28px] transition-all duration-[650ms] ease-[cubic-bezier(0.4,0,0.2,1)]"
            style={{
              width: isActive ? "100%" : "0%",
              background: `linear-gradient(90deg, ${accent}, ${accent}44)`,
            }}
          />
        </div>
      );
    }
    
    const C = {
      paper: "#f5f8ff",
      warm: "#beccf0", 
      ink: "#1E3A8A",
      accent: "#0072ff",
      muted: "#9a9a9b",
    } as const;
    
    const font = {
      serif: { fontFamily: "'Archivo', sans-serif" },
      mono: { fontFamily: "'Archivo', sans-serif" },
    } as const;
    
    interface Benefit {
      num: string;
      Icon: FC;
      title: string;
      text: React.ReactNode;
    }
    
    
    const BENEFITS: Benefit[] = [
      {
        num: "01 / 04",
        Icon: ShieldCheck ,
        title: "Secure Storage for Large Video Files ",
        text: (
        <>
          Store raw footage, edited videos, thumbnails, and project files safely with{" "}
          <a
            href="#security"
            target="_blank"
            rel="noopener noreferrer"
            className="text-[#0072ff] font-bold hover:underline"
          >
            SpaceByte cloud storage,
          </a>{" "}
          protecting content if devices fail.
        </>
      ),
      },
      {
        num: "02 / 04",
        Icon: Globe ,
        title: "Fast Uploads for Video Projects",
        text: "Upload large 4K or 8K video files quickly so your editing and publishing workflow stays smooth.",
      },
      {
        num: "03 / 04",
        Icon: FolderKanban  ,
        title: "Organized Video Project Folders",
        text: "Keep your raw footage, thumbnails, scripts, and final videos organized so you can find files quickly.",
      },
      {
        num: "04 / 04",
        Icon: Share2 ,
        title: "Easy Collaboration with Editors",
        text: "Share project folders with editors, designers, or sponsors using secure links for simple and secure collaboration.",
      },
    ];
    
    function useStyles(): void {
      useEffect(() => {
    
        // CSS Keyframes + Animations
        if (!document.getElementById("ben-css")) {
          const s = document.createElement("style");
          s.id = "ben-css";
          s.textContent = `
            .ben-reveal {
              opacity: 0;
              transform: translateY(28px);
              transition: opacity 0.75s ease, transform 0.75s ease;
            }
            .ben-reveal.visible {
              opacity: 1;
              transform: translateY(0);
            }
    
            .ben-card {
              position: relative;
              overflow: hidden;
              cursor: default;
            }
            .ben-card-inner {
              transition: background 0.4s ease;
            }
            .ben-card:hover .ben-card-inner {
              background: ${C.ink} !important;
            }
    
            .ben-card::after {
              content: '';
              position: absolute;
              bottom: 0; left: 0; right: 0;
              height: 2px;
              background: ${C.accent};
              transform: scaleX(0);
              transform-origin: left;
              transition: transform 0.4s ease;
            }
            .ben-card:hover::after { transform: scaleX(1); }
    
            .ben-num, .ben-title, .ben-text {
              transition: color 0.4s ease;
            }
            .ben-card:hover .ben-num { color: #1E3A8A !important; }
            .ben-card:hover .ben-title { color: ${C.paper} !important; }
            .ben-card:hover .ben-text { color: #d8d8da !important; }
    
            .ben-icon {
              width: 52px; height: 52px;
              display: flex; align-items: center; justify-content: center;
              border: 1.5px solid ${C.warm};
              background: ${C.warm};
              transition: all 0.4s ease;
            }
            .ben-icon svg { stroke: ${C.ink}; transition: stroke 0.4s ease; }
            .ben-card:hover .ben-icon {
              background: ${C.accent} !important;
              border-color: ${C.accent} !important;
            }
            .ben-card:hover .ben-icon svg { stroke: #ffffff; }
    
            .ben-card:nth-child(1) { transition-delay: 0s; }
            .ben-card:nth-child(2) { transition-delay: 0.08s; }
            .ben-card:nth-child(3) { transition-delay: 0.16s; }
            .ben-card:nth-child(4) { transition-delay: 0.24s; }
          `;
          document.head.appendChild(s);
        }
      }, []);
    }
    
    function useReveal(ref: React.RefObject<HTMLElement>): void {
      useEffect(() => {
        const el = ref.current;
        if (!el) return;
    
        const obs = new IntersectionObserver(
          ([entry]) => {
            if (entry.isIntersecting) {
              el.classList.add("visible");
              obs.disconnect();
            }
          },
          { threshold: 0.1 }
        );
        
        obs.observe(el);
        return () => obs.disconnect();
      }, [ref]);
    }
    
    const BenefitCard: FC<Benefit> = ({ num, Icon, title, text }) => (
      <div className="ben-card">
        <div
          className="ben-card-inner h-full"
          style={{
            background: C.paper,
            padding: "clamp(32px, 4vw, 52px) clamp(24px, 3.5vw, 44px)",
          }}
        >
          {/* <p
            className="ben-num font-archivo"
            style={{
              fontSize: 11,
              letterSpacing: "0.2em",
              color: C.muted,
              marginBottom: 24,
            }}
          >
            {num}
          </p> */}
    
          <div className="ben-icon rounded-2xl" style={{ marginBottom: 24 }}>
            <Icon />
          </div>
    
          <h3
            className="ben-title font-archivo font text-2xl"
            style={{
              color: C.ink,
              marginBottom: 12,
            }}
          >
            {title}
          </h3>
    
          <p
            className="ben-text font-archivo"
            style={{
              fontSize: "clamp(14px, 1.2vw, 15px)",
              lineHeight: 1.8,
              color: C.muted,
              fontWeight: 300,
              maxWidth: 360,
            }}
          >
            {text}
          </p>
        </div>
      </div>
    );
    
    function WhyCard({
      item,
    }: {
      item: {
        icon: LucideIcon;
        title: string;
        text: string;
      };
    }) {
      const { icon: Icon, title, text } = item;
    
      return (
        <div
          className="
            relative overflow-hidden rounded-[16px] border
            p-[32px_28px]
            transition-all duration-500
            ease-[cubic-bezier(0.4,0,0.2,1)]
            hover:-translate-y-[6px]
            hover:shadow-[0_16px_40px_rgba(0,112,255,0.12)]
          "
          style={{
            background: "#f5f8ff",
            borderColor: "#e4edff",
    
            /* ✅ Top Gradient Line (Best Professional Way) */
            backgroundImage:
              "linear-gradient(90deg, #0070ff, #00c6ff)",
            backgroundSize: "100% 4px",
            backgroundRepeat: "no-repeat",
            backgroundPosition: "top",
          }}
        >
          {/* Icon */}
          <div
            className="w-[50px] h-[50px] rounded-[12px] flex items-center justify-center text-[22px] mb-[18px]"
            style={{
              background: "#eaf3ff",
            }}
          >
            <Icon size={22} strokeWidth={2} className="text-[#0070ff]" />
          </div>
    
          {/* Title */}
          <h3 className="text-[16px] font-bold text-[#0d0d2b] mb-[10px]">
            {title}
          </h3>
    
          {/* Text */}
          <p className="text-[13.5px] text-[#7a8fa6] leading-[1.7]">
            {text}
          </p>
        </div>
      );
    }

    function useInView(threshold = 0.15) {
  const ref = useRef<HTMLDivElement>(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold }
    );
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, [threshold]);
  return { ref, visible };
}
 
function MigrationArrow() {
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setProgress(p => (p >= 100 ? 0 : p + 2));
    }, 30);
    return () => clearInterval(timer);
  }, []);
  return (
    <div style={{ position: "relative", display: "flex", alignItems: "center", width: 90 }}>
      {/* Track */}
      <div style={{
        width: "100%", height: 3, background: "#e8edf5", borderRadius: 4,
        position: "relative", overflow: "hidden"
      }}>
        <div style={{
          position: "absolute", top: 0, left: 0, height: "100%",
          width: `${progress}%`, background: "linear-gradient(90deg, #3b6ef8, #5b8afe)",
          borderRadius: 4, transition: "width 0.03s linear"
        }}/>
      </div>
      {/* Arrow head */}
      <div style={{ marginLeft: 6, color: "#3b6ef8" }}>
        <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
          <line x1="5" y1="12" x2="19" y2="12"/>
          <polyline points="12 5 19 12 12 19"/>
        </svg>
      </div>
    </div>
  );
}
 
function LogoBox({ children, label, sub }: { children: React.ReactNode; label: string; sub: string }) {
  return (
    <div style={{ textAlign: "center" }}>
      <div style={{
        width: 96, height: 96,
        background: "#fff",
        border: "2px dashed #d0d9f0",
        borderRadius: 22,
        display: "flex", alignItems: "center", justifyContent: "center",
        boxShadow: "0 4px 24px rgba(59,110,248,0.07)",
        margin: "0 auto 10px",
        fontSize: 42,
      }}>
        {children}
      </div>
      <div style={{ fontFamily: "'Sora', sans-serif", fontWeight: 700, fontSize: 15, color: "#1a2340" }}>{label}</div>
      <div style={{ fontFamily: "'DM Sans', sans-serif", fontSize: 12, color: "#8a96b0", marginTop: 2 }}>{sub}</div>
    </div>
  );
}


export default function ComparisonSection() {
  const styleInjected = useRef(false);
  const COMPARISON_CSS = `
  .cmp-section {
    position: relative;
    overflow: hidden;
    background: #f5f8ff;
    padding: 5rem 1rem;
    color: #000;
  }
  .cmp-inner {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 1rem;
  }
  .cmp-heading {
    text-align: center;
    margin-bottom: 3.5rem;
  }
  .cmp-heading h2 {
    font-family: 'Archivo', sans-serif;
    font-size: clamp(1.6rem, 4vw, 3rem);
    font-weight: 700;
    line-height: 1.2;
    margin-bottom: 1rem;
  }
  .cmp-heading h2 .gradient-text {
    background: linear-gradient(90deg, #0072ff, #00c6ff);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }
  .cmp-heading p {
    font-family: 'Inter', sans-serif;
    color: #6b7280;
    font-size: 0.95rem;
    max-width: 600px;
    margin: 0 auto;
    line-height: 1.7;
  }

  /* Logo Row */
  .cmp-logo-row {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    margin-bottom: 2.5rem;
    flex-wrap: wrap;
  }
  .cmp-logo-card {
    width: 110px;
    height: 110px;
    border-radius: 20px;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 10px 30px rgba(0,0,0,0.08);
    overflow: hidden;
    flex-shrink: 0;
  }
  .cmp-logo-card img {
    width: 80%;
    height: 80%;
    object-fit: contain;
    padding: 8px;
  }
  .cmp-vs {
    width: 46px;
    height: 46px;
    border-radius: 50%;
    background: linear-gradient(135deg, #1E3A8A, #3B82F6);
    color: #fff;
    font-weight: 700;
    font-size: 0.82rem;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  /* Table wrapper — horizontal scroll on small screens */
  .cmp-table-wrap {
    max-width: 1000px;
    margin: 0 auto;
    border-radius: 16px;
    box-shadow: 0 10px 40px rgba(0,0,0,0.08);
  }
  /* Scroll hint on mobile */
  .cmp-scroll-hint {
    display: none;
    text-align: center;
    font-size: 0.75rem;
    color: #94a3b8;
    margin-bottom: 0.5rem;
  }

  /* Table */
  .cmp-table {
    width: 100%;
    border-collapse: separate;
    border-spacing: 0;
    background: #fff;
    border-radius: 16px;
  }
  .cmp-table thead tr th {
    padding: 14px 18px;
    font-size: 0.82rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.06em;
  }
  .cmp-th-feature {
    text-align: left;
    background: #eff6ff;
    color: #2563eb;
    width: 34%;
  }
  .cmp-th-gdrive {
    background: #f5f3ff;
    color: #7c3aed;
    text-align: center;
    width: 33%;
  }
  .cmp-th-space {
    background: #eff6ff;
    color: #2563eb;
    text-align: center;
    width: 33%;
  }
  .cmp-table tbody tr td {
    padding: 13px 18px;
    border-top: 1px solid #f1f5f9;
    font-size: 0.84rem;
    vertical-align: middle;
    line-height: 1.5;
  }
  .cmp-table tbody tr td:first-child {
    color: #475569;
    text-align: left;
    font-weight: 500;
  }
  .cmp-table tbody tr td:not(:first-child) {
    text-align: center;
    color: #334155;
  }
  .cmp-table tbody tr:nth-child(even) {
    background: #f8fafc;
  }

  /* Highlight SpaceByte wins */
  .cmp-win {
    color: #16a34a;
    font-weight: 600;
  }
  .cmp-neutral {
    color: #334155;
  }

  /* Responsive */
  @media (max-width: 700px) {
    .cmp-scroll-hint { display: block; }
    .cmp-logo-card { width: 88px; height: 88px; border-radius: 14px; }
    .cmp-vs { width: 38px; height: 38px; font-size: 0.72rem; }
    .cmp-section { padding: 3.5rem 1rem; }
  }
  @media (max-width: 480px) {
    .cmp-logo-card { width: 72px; height: 72px; border-radius: 12px; }
  }

  @media (max-width: 700px) {
  .cmp-table thead {
    display: none;
  }

  .cmp-table,
  .cmp-table tbody,
  .cmp-table tr,
  .cmp-table td {
    display: block;
    width: 100%;
  }

  .cmp-table tr {
    margin-bottom: 1rem;
    border-radius: 12px;
    background: #ffffff;
    box-shadow: 0 6px 20px rgba(0,0,0,0.06);
    padding: 10px;
  }

  .cmp-table td {
    text-align: left !important;
    padding: 10px 12px;
    border: none;
    position: relative;
  }

  .cmp-table td::before {
    content: attr(data-label);
    font-weight: 600;
    color: #2563eb;
    display: block;
    margin-bottom: 4px;
    font-size: 0.75rem;
  }
}
`;

interface ComparisonRow {
  title: string;
  gdrive: string;
  space: string;
  spaceWins?: boolean;
}

const rows: ComparisonRow[] = [
  {
    title: "Security",
    gdrive: "Google security infrastructure",
    space: "AES-256 + TLS 1.3 encryption",
    spaceWins: true,
  },
  {
    title: "End-to-End Encryption",
    gdrive: "No",
    space: "Yes",
    spaceWins: true,
  },
  {
    title: "Speed",
    gdrive: "Upload 5 Mbps / Download 400 Kbps",
    space: "High-speed upload & download",
    spaceWins: true,
  },
  {
    title: "Price (India)",
    gdrive: "₹130/month (100 GB)",
    space: "₹20–₹150/month (50 GB–1 TB) + unlimited options",
    spaceWins: true,
  },
  {
    title: "Free Tier",
    gdrive: "15 GB",
    space: "25 GB",
    spaceWins: true,
  },
  {
    title: "Ads Shown",
    gdrive: "No",
    space: "No",
  },
  {
    title: "Maximum File Size",
    gdrive: "Up to 5 TB",
    space: "No file size restrictions",
    spaceWins: true,
  },
  {
    title: "Daily Upload Limit",
    gdrive: "750 GB per day limit",
    space: "No daily upload limits",
    spaceWins: true,
  },
  {
    title: "Large File Handling",
    gdrive: "Can feel restrictive for heavy use",
    space: "Smooth handling of large files",
    spaceWins: true,
  },
  {
    title: "Workflow",
    gdrive: "Uploads stop after hitting limits",
    space: "No interruptions",
    spaceWins: true,
  },
];


  useEffect(() => {
    if (styleInjected.current) return;
    styleInjected.current = true;
    const tag = document.createElement("style");
    tag.innerHTML = COMPARISON_CSS;
    document.head.appendChild(tag);
  }, []);

  return (
    <section className="cmp-section">
      <div className="cmp-inner">

        {/* Heading */}
        <div className="cmp-heading">
          <h2 className="animate-fade-down">
            Google Drive{" "}
            <span className="gradient-text"> vs </span>
            SpaceByte Cloud
          </h2>
          <p className="animate-fade-down">
            Bring your files to SpaceByte and enjoy more space, better control,
            and a simpler way to manage your data without constant limits.
          </p>
        </div>

        {/* Logo Row */}
        <div className="cmp-logo-row">
          <div className="cmp-logo-card">
            <img
              src="/images/google-drive-alternative/google-drive.webp"
              alt="Google Drive"
            />
          </div>
          <div className="cmp-vs">VS</div>
          <div className="cmp-logo-card">
            <img
              src="/images/google-drive-alternative/spacebyte.webp"
              alt="SpaceByte"
            />
          </div>
        </div>

        {/* Scroll hint on mobile */}
        <p className="cmp-scroll-hint">← Scroll to see full comparison →</p>

        {/* Table */}
        <div className="cmp-table-wrap">
          <table className="cmp-table">
            <thead>
              <tr>
                <th className="cmp-th-feature">Feature / Provider</th>
                <th className="cmp-th-gdrive">Google Drive</th>
                <th className="cmp-th-space">SpaceByte</th>
              </tr>
            </thead>
            <tbody>
              {rows.map((row, i) => (
                <tr key={i}>
                  <td data-label="Feature">{row.title}</td>
                  <td data-label="Google Drive" className="cmp-neutral">
                    {row.gdrive}
                  </td>
                  <td
                    data-label="SpaceByte"
                    className={row.spaceWins ? "cmp-win" : "cmp-neutral"}
                  >
                    {row.space}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

      </div>
    </section>
  );
}